<div [class]="className">
  <div class="notification__content">
    <mat-icon *ngIf="icon" class="notification__icon">{{icon}}</mat-icon>
    <p class="notification__message">{{message}}</p>
  </div>
  <mat-icon class="notification__remove" (click)="handleClick()" *ngIf="type === 'click'">
    close
  </mat-icon>
</div>
